import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles((theme) => ({
  button: ({ icon, iconButton }) => ({
    position: 'relative',
    width: '100%',
    fontWeight: 'var(--ui-button-font-weight)',
    border: 'var(--ui-button-border-width) solid currentColor',
    borderRadius: 'var(--ui-button-border-radius)',
    fontSize: 'var(--ui-button-font-size)',
    // padding: props.mobilePadding,
    backgroundColor: theme.colors.background,
    color: theme.colors.primary,
    textTransform: 'uppercase',
    alignItems: 'center',
    cursor: 'pointer',
    outline: 'none',
    height: 'auto',
    lineHeight: 1,
    padding: '1.5rem 2rem',
    ...(iconButton ? {
      padding: '1.5rem 2rem 1.5rem 4.2rem',
    } : {}),
    ...(icon ? {
      lineHeight: 'normal',
      border: 'none',
      width: 'auto',
      backgroundColor: 'transparent',
      padding: '1.25rem 1.1rem',
      '&:before': {
        content: '""',
        display: 'var(--ui-favourite-button-background-display)',
        width: '80%',
        height: 0,
        paddingBottom: '80%',
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        borderRadius: '100%',
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        boxShadow: '0 0 4px 0 rgba(0,0,0,0.15)',
      },
    } : {}),
  }),
  buttonDisabled: ({ icon }) => ({
    color: theme.colors.disabled,
    border: `2px solid ${theme.colors.disabled}`,
    ...(icon ? {
      border: 'none',
    } : {}),
  }),
  icon: ({ icon, like }) => ({
    margin: 0,
    display: 'block',
    position: 'absolute',
    left: '1.4rem',
    top: '50%',
    color: like ? theme.colors.secondary : theme.colors.text,
    opacity: 1,
    transform: 'translateY(-50%)',
    ...(icon ? {
      position: 'relative',
      top: 'auto',
      left: 'auto',
      zIndex: 1,
      transform: 'none',
    } : {}),
  }),
  iconDisabled: () => ({
    opacity: 0.5,
  }),
}))

export default useStyles
